import { render, staticRenderFns } from "./ItemUpdateFormTab.vue?vue&type=template&id=70b79896"
import script from "./ItemUpdateFormTab.vue?vue&type=script&lang=js"
export * from "./ItemUpdateFormTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports